import { useEffect } from 'react';
import DataTable from 'react-data-table-component';
import CustomPagination from '../../elements/CustomPagination';
import { useCRMSellers } from './hooks/useCRMSellers'; 
import { customStylesCrm } from '../../../util/TableStyles';
import { noDataComponent } from '../../../util/DataObject';
import { FlexGrid, Typography, useThemeProvider, Card, Skeleton } from '@albo-ui/core';
import { Box, IconButton, MenuItem, TextField, InputAdornment, FormControl, InputLabel, Select, Divider } from '@mui/material';
import { sellerRole, status } from '../../../util/DataObject';
import { ItemConfirmDialog } from '../../modals/confirm';
import { ManageSeller } from '../../modals/sales-manager/ManageSeller';
import { CRMSalesProps } from './types';

import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import SearchIcon from '@mui/icons-material/Search';


export const CRMSellersTable = ({ changeAlert, changeLoader, sectionData }: CRMSalesProps) => {    
    const { data, form, columns, loading: loadingTable, pagination, dialogConfirm, dialogText, dialogProps, row, saveData, onHandleChange, onHandleFind, changePage, handleChangeRowsPerPage, onHandleDelete, onHandleUpdate, setRow, onHandleForm, onHandleCreate } = useCRMSellers(changeAlert);
    const { theme } = useThemeProvider();

    const onCloseDialogConfirm = () => {
        dialogConfirm.onClose();
        setRow(null);
    };
    const onCloseDialogAction = () => {
        dialogProps.onClose();
        setRow(null);
    };

    useEffect(() => {
        saveData(sectionData)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        changeLoader(loadingTable)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingTable]);

    
    return (
        <>
            <Card padding={4} flexDirection='column' fullWidth fullHeight alignItems='stretch' justifyContent='space-between' style={{ borderColor: theme.colors.manatee, marginTop: 3 }}> 
                <FlexGrid container fullWidth justify='space-between'>
                    {loadingTable ? 
                        <Skeleton width='100%' height='100px' style={{marginTop: 20}} />
                        :
                        <>
                        <FlexGrid item>
                            <Typography variant='h2' style={{display: 'flex', alignItems: 'center', fontSize: '1.2rem'}}>
                                <SupportAgentIcon sx={{ marginRight: 1 }}/> Administrador de Vendedores
                            </Typography>
                            <Box my={1} sx={{ fontStyle: 'italic', fontWeight: '500 !important' }}>
                                {pagination.totalDocuments} registro(s)
                            </Box>
                        </FlexGrid>
                        <IconButton title='Crear vendedor' onClick={() => onHandleForm()} sx={{padding: '0 !important'}}><PersonAddIcon sx={{padding: '7px', borderRadius: 2, boxSizing: 'content-box', color: 'white', backgroundColor: '#8bc179' }}/></IconButton>
                        </>

                    }
                </FlexGrid>

                <FlexGrid container spacing={2} style={{marginBlock: '2%', justifyContent: 'space-between'}} >
                    <FlexGrid item container spacing={2} style={{width: '75%'}} >
                        <FormControl color='secondary' sx={{ width: '25%'}}>
                            <InputLabel>Rol</InputLabel>
                            <Select labelId='select-role' value={(form['filters'] && form['filters']['role']) || ''} color='secondary' onChange={onHandleChange.bind(this, 'role', true)} >
                                <MenuItem value={''}>Todos</MenuItem>
                                { sellerRole.map((item, index) => {
                                    return <MenuItem value={item.key} key={`item-rol-${index}`}>{item.label}</MenuItem>
                                })}
                            </Select>
                        </FormControl>
                        <FormControl color='secondary' sx={{ width: '25%'}}>
                            <InputLabel>Estatus</InputLabel>
                            <Select labelId='select-status' value={(form['filters'] && form['filters']['status']) || ''} color='secondary' onChange={onHandleChange.bind(this, 'status', true)}>
                                <MenuItem value={''}>Todos</MenuItem>
                                { status.map((item, index) => {
                                    return <MenuItem value={item.value} key={`item-status-${index}`}>{item.label}</MenuItem>
                                })}
                            </Select>
                        </FormControl>
                    </FlexGrid>

                    <FlexGrid item>
                        <FormControl fullWidth color='secondary'>
                        <TextField label='Email' value={(form['filters'] && form['filters']['keyword']) || ''} onChange={onHandleChange.bind(this, 'email', false)} fullWidth 
                            InputProps={{
                                endAdornment: <InputAdornment position='end'>
                                    <IconButton onClick={onHandleFind.bind(this, form)}>
                                        <SearchIcon />
                                    </IconButton>
                                </InputAdornment>
                            }}
                            />
                        </FormControl>
                    </FlexGrid>
                </FlexGrid>

                <Divider/>
                {loadingTable ? 
                    <Skeleton width='100%' height='100px' style={{marginTop: 20}} />
                    :
                    <>
                        <FlexGrid container style={{margin: '25px 0' }} direction='column'>
                            {
                                loadingTable ?
                                    <Skeleton width='100%' height='100px' />
                                    :
                                    <>
                                    <DataTable
                                        columns={columns}
                                        data={data}
                                        customStyles={customStylesCrm}
                                        noDataComponent={noDataComponent}
                                        progressPending={loadingTable}
                                        expandOnRowClicked={false}
                                    />
                                    <CustomPagination 
                                        rows={pagination.totalDocuments}
                                        page={pagination.page - 1}
                                        rowsPerPage={pagination.rowsPerPage}
                                        handleChangePage={changePage}
                                        handleChangeRowsPerPage={handleChangeRowsPerPage}
                                    />
                                    </>

                            }
                        </FlexGrid>
                    </>

                }
            </Card>
            <ItemConfirmDialog 
                open={dialogConfirm.open}
                title={dialogText["title"]}
                message={dialogText["message"]}
                onClose={onCloseDialogConfirm} 
                onConfirm={onHandleDelete.bind(this)} 
                item={row && row["name"]}
            />
            
            <ManageSeller 
                item={row}
                open={dialogProps.open}
                onClose={onCloseDialogAction}
                onConfirm={row ? onHandleUpdate.bind(this) : onHandleCreate.bind(this)}
                changeLoader={changeLoader}
                changeAlert={changeAlert}
            />
            
        </>
    )
};